import { useEffect, useState } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import QRCodeButton from "../QRCodeButton";
import CustomCard from "../CustomCard";
import { useQuery } from "@apollo/client";
import { LOAD_STATIONEN } from "../../GraphQL/Queries";
import LeafletMap from "./LeafletMap";

const useStyles = makeStyles(() => ({
  map: {
    height: "200px",
    position: "fixed",
    top: 0,
    width: "100%",
    zIndex: 1,
  },
  root: {
    paddingTop: "220px",
    paddingBottom: "50px",
  },
  title: {
    marginLeft: "15px",
  },
}));

function Stationen({ navigate }) {
  //error and loading are also possible but currently not included becuase of Vercel
  const { data } = useQuery(LOAD_STATIONEN);
  const [stationen, setStationen] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    if (data) {
      setStationen(data.stationCollection.items);
    }
  }, [data]);

  return (
    <div className={classes.root}>
      <div className={classes.map}>
        <LeafletMap />
      </div>
      <QRCodeButton />
      <div>
        <Typography component="h1" variant="h4" className={classes.title}>
          <Box fontWeight={600}>Stationen</Box>
        </Typography>
        {stationen.map((st, idx) => {
          return (
            <CustomCard
              station
              key={idx}
              name={st.stationsname}
              description={st.beschreibung}
              nr={st.stationsnummer}
              count={st.uebungenCollection.items.length}
              img={st.stationsbild.url}
              navigate={navigate}
            />
          );
        })}
      </div>
    </div>
  );
}

export default Stationen;
